<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('faqs.categories.create')
  }),
  computed: {
    ...mapState('faqsCategories', ['routeKey', 'routes', 'form', 'item']),
    crumbs: (vm) => [
      { text: vm.$t('faqs.title'), to: { name: 'faqs.index' } },
      { text: vm.$t('faqs.categories.title'), to: { name: 'faqs.categories.index' } },
      { text: vm.$t('faqs.categories.create') }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('faqsCategories/clearItem')
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('faqsCategories', ['createItem', 'updateItem'])
  }
}
</script>
